const caseInsensitiveUrlParam = (queryParams: URLSearchParams, paramString: string): string => {
    const listOfParams = Array.from(queryParams.keys());
    const searchedParam = listOfParams.find((item) => item.toLowerCase() === paramString.toLowerCase());
    return queryParams.get(searchedParam);
};

export default caseInsensitiveUrlParam;
